<template>
  <div class="flex p-2 h-full flex-1" :class="isMobile?'flex-col':''">
    <div class="flex flex-col p-2 flex-1">
      <div class="flex pb-2">
        <el-select v-model="method" placeholder="请求类型" class="mr-2" @change="setItem">
          <el-option v-for="(item, index) in methods" :key="index" :value="item" :label="item"></el-option>
        </el-select>
        <el-input v-model="url" placeholder="请求地址" class="mr-2" @input="setItem"></el-input>
        <el-button type="primary" @click="send" :loading="loading">发送</el-button>
      </div>
      <div class="flex py-2 justify-between">
        <span>参数：<a @click="addParameter" v-show="inputType == 1">添加一项</a></span>
        <span>
          <a @click="changeParameterType(2)" v-show="inputType == 1">Raw</a>
          <a @click="changeParameterType(1)" v-show="inputType == 2">Key/Value</a>
        </span>
      </div>
      <div v-for="(item, index) in parameterList" :key="'parameters'+index" class="flex items-center py-1" v-show="inputType == 1">
        <div class="mr-2 cursor-pointer" @click="removeParameter(index)">
          <i class="el-icon-delete"></i>
        </div>
        <el-input v-model="item.key" placeholder="key" class="mr-2" @input="setItem"></el-input>
        <el-input v-model="item.value" placeholder="value" class="mr-2" @input="setItem"></el-input>
      </div>
      <div v-show="inputType == 2" class="flex h-32">
        <el-input type="textarea" placeholder="请输入内容" v-model="parameterJson" @input="setItem"></el-input>
      </div>
      <div class="flex py-2">
        <span>Headers：<a @click="addHeader">添加一项</a></span>
      </div>
      <div v-for="(item, index) in headers" :key="'headers'+index" class="flex items-center py-1">
        <div class="mr-2 cursor-pointer" @click="removeHeader(index)">
          <i class="el-icon-delete"></i>
        </div>
        <el-input v-model="item.key" placeholder="key" class="mr-2" @input="setItem"></el-input>
        <el-input v-model="item.value" placeholder="value" class="mr-2" @input="setItem"></el-input>
      </div>
    </div>
    <div class="flex flex-col p-2 flex-1">
      <div class="flex pb-2">
        <el-button :type="resType == 1 ? 'primary' : ''" @click="changeType(1)">返回结果</el-button>
        <el-button :type="resType == 2 ? 'primary' : ''" @click="changeType(2)">生成文档</el-button>
      </div>
      <div id="jsoneditor" class="flex-1" v-show="resType === 1"></div>
      <el-input type="textarea" class="flex-1" placeholder="请输入内容" v-model="markdown" v-show="resType === 2"></el-input>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import JSONEditor from "jsoneditor";
import "jsoneditor/dist/jsoneditor.min.css";

export default {
  name: "send",
  data() {
    return {
      methods: ["GET", "POST", "PUT", "DELETE"],
      method: "GET",
      url: "",
      parameterList: [],
      headers: [],
      response: null,
      markdown: "",
      resType: 1,
      editor: null,
      loading: false,
      parameterJson: "",
      inputType: 1,
      config: {},
    };
  },
  mounted() {
    var container = document.getElementById("jsoneditor");
    var options = {
      mode: "code",
      modes: ["code", "form", "text", "tree", "view"],
      onChange: this.changeJson,
    };
    this.editor = new JSONEditor(container, options);
    var data = JSON.parse(localStorage.getItem("runapi_data"));
    if (data) {
      this.method = data.method;
      this.url = data.url;
      this.parameterList = data.parameterList;
      this.headers = data.headers;
      this.parameterJson = data.parameterJson;
      this.inputType = data.inputType;
    }
  },
  computed: {
    localData() {
      return {
        method: this.method,
        url: this.url,
        parameterList: this.parameterList,
        headers: this.headers,
        parameterJson: this.parameterJson,
        inputType: this.inputType,
      };
    },
    isMobile() {
      return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|wOSBrowser|BrowserNG|WebOS)/i.test(navigator.userAgent);
    },
  },
  methods: {
    changeJson() {
      try {
        this.response = this.editor.get();
      } catch (error) { }
    },
    setItem() {
      localStorage.setItem("runapi_data", JSON.stringify(this.localData));
    },
    addParameter() {
      this.parameterList.push({
        key: "",
        value: "",
      });
      this.setItem();
    },
    removeParameter(index) {
      this.parameterList.splice(index, 1);
      this.setItem();
    },
    addHeader() {
      if (!this.headers) {
        this.headers = [];
      }
      this.headers.push({
        key: "",
        value: "",
      });
      this.setItem();
    },
    removeHeader(index) {
      this.headers.splice(index, 1);
      this.setItem();
    },
    changeParameterType(type) {
      this.inputType = type;
      if (type == 2) {
        var data = {};
        this.parameterList.forEach((value) => {
          if (value.key) {
            data[value.key] = value.value;
          }
        });
        this.parameterJson = JSON.stringify(data);
      } else {
        this.parameterList = [];
        try {
          var data = JSON.parse(this.parameterJson);
          for (var key in data) {
            this.parameterList.push({
              key: key,
              value: data[key],
            });
          }
        } catch (e) { }
      }
      this.setItem();
    },
    streamline(data) {
      if (data instanceof Array) {
        for (var item of data) {
          this.streamline(item);
        }
      } else if (data) {
        for (var key in data) {
          var val = data[key];
          if (val instanceof Array && val.length) {
            val.splice(1, val.length);
            this.streamline(val[0]);
          }
        }
      }
    },
    send() {
      if (!this.url) {
        return;
      }
      this.loading = true;
      var data = {};
      this.parameterList.forEach((value) => {
        if (value.key) {
          data[value.key] = value.value;
        }
      });
      this.parameter = data;
      var header = {};
      this.headers.forEach((value) => {
        if (value.key) {
          header[value.key] = value.value;
        }
      });
      api(this.url, this.method, this.parameter, header).then(
        (res) => {
          this.streamline(res.data);
          this.response = res.data;
          this.config = res.config;
          this.dataFormat();
          this.loading = false;
        },
        (err) => {
          this.loading = false;
          this.response = err;
          this.changeType(1);
        }
      );
    },
    changeType(type) {
      this.resType = type;
      this.dataFormat();
    },
    formatData(list, markdown = "", formatType = 1) {
      var temp = [];
      var table = [];
      for (var i = 0; i < list.length; i++) {
        var map = [];
        var item = list[i];
        for (var key in item.value) {
          var val = item.value[key];
          var type = val == null ? "unknown" : typeof val;
          if (val instanceof Array) {
            type = "array";
          }
          map.push({
            key: key,
            type: type,
            value: val,
          });
          if (val instanceof Array && val.length) {
            if (typeof val[0] == "object") {
              temp.push({
                name: key,
                value: val[0],
              });
            }
          } else if (val instanceof Object) {
            temp.push({
              name: key,
              value: val,
            });
          }
        }
        table.push({
          name: item.name,
          value: map,
        });
      }
      for (var item of table) {
        markdown += `\n\n**${item.name}：**\n\n`;
        if (item.value && item.value.length) {
          markdown += `|参数名${formatType === 1 ? "| 必选" : ""
            }|类型|说明|\n|:----    ${formatType === 1 ? "|:---" : ""
            }|:----- |-----   |`;
          for (var val of item.value) {
            markdown += `\n| ${val.key} ${formatType === 1 ? "| 是" : ""} | ${val.type
              } | 无 |`;
          }
        } else {
          markdown += "无";
        }
      }
      if (temp.length) {
        return this.formatData(temp, markdown, formatType);
      }
      return markdown;
    },
    dataFormat() {
      if (!this.response) {
        this.markdown = "";
        return;
      }
      if (!this.config.data) {
        this.markdown = this.formatData(
          [{ name: "参数说明", value: this.response }],
          "",
          2
        );
        return;
      }
      this.editor.set(this.response);

      this.markdown = `
**简要描述：** 

- 描述

**请求URL：** 

- \`${this.url}\`

**请求方式：**
- ${this.method}
${this.formatData([
        {
          name: "参数说明",
          value: this.config.data ? JSON.parse(this.config.data) : "",
        },
      ])}

 **返回示例**

\`\`\` 
${this.editor.getText()}
\`\`\`
${this.formatData([{ name: "返回参数说明", value: this.response }], "", 2)}

 **备注** 

- 更多返回错误代码请看全局的错误代码描述`;
    },
  },
};
</script>

<style>
a {
  color: #3883fa;
  cursor: pointer;
  padding: 0 10px;
}
textarea {
  width: 100%;
  height: 100%;
  font-size: 12px;
}
#jsoneditor .jsoneditor-poweredBy {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/send.vue